import React from 'react';
import styles from './index.module.less';
import cs from 'classnames';

interface V2WaterMarkProps {
  /**
   * @description 额外插入的外层class
   */
  className?: string;
  /**
   * @description 水印内容
   */
  content?: string;
  /**
   * @description 选择角度，单位deg
   */
  rotate?: number;
  /**
   * @description 文本颜色
   */
  color?: string;
  /**
   * @description 文本字体大小
   */
  fontSize?: string;
  /**
   * @description 透明度
   */
  opacity?: number;
  /**
   * @description 是否显示
   */
  show?: boolean;
  /**
   * @description 水印数量，如果项目内有长页面，建议设置更大
   */
  total?: number;
  /**
   * @description 层级
   */
  zIndex?: number;
  /**
   * @description 定位上下左右间隔
   * @default { top: 0, left: 0, right: 0, bottom: 0 }
   */
  positionPX?: any;
  /**
   * @description 是否使用局部水印，默认false，往页面层级插入
   */
  module?: boolean;
}
/**
* @description 便捷文档地址
* @see https://reactpc.lanhanba.net/components/others/v2water-mark
*/
const V2WaterMark: React.FC<V2WaterMarkProps> = ({
  className,
  content = '我是水印',
  rotate = '-15',
  color = '#000',
  fontSize = '18px',
  opacity = 0.06,
  show = true,
  total = 200,
  positionPX,
  module = false,
  zIndex = 99999,
}) => {
  const list = new Array(total).fill(0);
  const _positionPX = Object.assign({
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }, positionPX);
  return (
    <div
      className={cs(styles.V2WaterMarkWrapper, className)}
      style={{
        display: show ? 'block' : 'none',
        position: module ? 'relative' : 'fixed',
        zIndex,
        ..._positionPX
      }}
    >
      {
        list.map((_, index) => (
          <span
            className={styles.V2WaterMark}
            style={{
              opacity
            }}
            key={index}
          >
            <span
              key={index}
              className={styles.V2WaterMarkInner}
              style={{
                transform: `translate(-50%, -50%) rotate(${rotate}deg)`,
                fontSize,
                color
              }}
            >
              {content}
            </span>
          </span>
        ))
      }
    </div>
  );
};

export default V2WaterMark;
